import { useContext } from "react"
import { Box, TextField, Grid, Typography } from "@mui/material"
import { ToolContext } from "../../../../core/context/ToolContext"
import {Check as CheckIcon, BlockRounded as BlockRoundedIcon} from '@mui/icons-material';

export const FormFooter = ({handleChange, handleDecline, handleSubmit, role}) =>{
    const {reconciliation_state, session_state} = useContext(ToolContext)
    const {navSession} = session_state
    const {reconData, isToReconcile} = reconciliation_state
    return (
        <>
            {role !== "Regular User" &&
                <Box mb={2}>
                    <Grid item xs={12}>
                        <TextField fullWidth label="Remarks" name="remarks" value={reconData.data.remarks} multiline minRows={2} disabled />
                    </Grid>
                </Box>
            }
            <Grid item xs={12}><TextField fullWidth label="Reconciled Remarks" disabled={!isToReconcile.data} name="reconciledRemarks" multiline minRows={2} value={reconData.data.reconciledRemarks} onChange={handleChange} /></Grid>
            {!navSession.data.isShow && isToReconcile.data && role === "Regular User" && (
                <Box sx={{ position: "sticky", left: 0, mt: 2, mb: 8 }}>
                    <Box px={3} py={1.5} display="flex" alignItems="center" justifyContent="center" gap={1} textAlign="center" borderRadius={3} onClick={handleSubmit} sx={{ cursor: "pointer", width: "100%", bgcolor: "primary.main", color: "#fff", fontWeight: 600, fontSize: 15, letterSpacing: 0.5, boxShadow: 2, transition: "all 0.3s ease" }}>
                    <CheckIcon fontSize="small" /> Submit
                    </Box>
                </Box>
            )}

            {!navSession.data.isShow && ((role === "Supervisor" && reconData.data.status === 2) || (role === "Accounting" && reconData.data.status === 3)) && (
                <Box display="flex" mt={2} gap={1} flexDirection="end">
                    <Box px={3} py={1.5} display="flex" alignItems="center" justifyContent="center" gap={1} textAlign="center" borderRadius={3} onClick={handleSubmit} sx={{ cursor: "pointer", width: "100%", bgcolor: "primary.main", color: "#fff", fontWeight: 600, fontSize: 15, letterSpacing: 0.5, boxShadow: 2, transition: "all 0.3s ease" }}>
                        <CheckIcon fontSize="small" /> <Typography fontSize={12}>{role === "Supervisor" ? "Recommend" : "Approve"}</Typography>
                    </Box>
                    <Box px={3} py={1.5} display="flex" alignItems="center" justifyContent="center" gap={1} textAlign="center" borderRadius={3} onClick={handleDecline} sx={{ cursor: "pointer", width: "100%", bgcolor: "error.main", color: "#fff", fontWeight: 600, fontSize: 15, letterSpacing: 0.5, boxShadow: 2, transition: "all 0.3s ease" }}>
                        <BlockRoundedIcon fontSize="small" /> <Typography fontSize={12}>Decline</Typography>
                    </Box>
                </Box>
            )}
        
        </>
    )
}